const AuditConstants = {
  GET_OPERATION_AUDIT_SUCCESS: "GET_OPERATION_AUDIT_SUCCESS",
  GET_OPERATION_AUDIT_FAILURE: "GET_OPERATION_AUDIT_FAILURE",
  GET_OPERATION_AUDIT_LOG_SUCCESS: "GET_OPERATION_AUDIT_LOG_SUCCESS",
  GET_OPERATION_AUDIT_LOG_FAILURE: "GET_OPERATION_AUDIT_LOG_FAILURE",
  GET_AUDIT_FIELD_LOG_SUCCESS: "GET_AUDIT_FIELD_LOG_SUCCESS",
  GET_AUDIT_FIELD_LOG_FAILURE: "GET_AUDIT_FIELD_LOG_FAILURE",
  GET_AUDIT_OBJECT_LOG_SUCCESS: "GET_AUDIT_OBJECT_LOG_SUCCESS",
  GET_AUDIT_OBJECT_LOG_FAILURE: "GET_AUDIT_OBJECT_LOG_FAILURE",
  GET_SEARCH_FIELD_SUCCESS: "GET_SEARCH_FIELD_SUCCESS",
  GET_SEARCH_FIELD_FAILURE: "GET_SEARCH_FIELD_FAILURE",
};
export default AuditConstants;
